import { BigNumber, utils } from 'ethers'
import { Pool } from '~/pages/CrossChainFarmPage'
import { ChainId } from 'symbiosis-js-sdk'

export const hasProjectTokens = (pool: Pool) => {
	const tokensChainIds = [pool.tokenA.chainId, pool.tokenB.chainFromId]
	const chainIds = [ChainId.BOBA_MAINNET, ChainId.BOBA_RINKEBY]

	let found = false

	for (let i = 0; i < chainIds.length; i++) {
		for (let j = 0; j < tokensChainIds.length; j++) {
			if (chainIds[i] === tokensChainIds[j]) {
				found = true
				break
			}
		}
	}
	return found
}

export const toAmount = (decimals: number, value: BigNumber): string => {
	return utils.formatUnits(value, decimals)
}
export const toBigNumber = (decimals: number, value: string): BigNumber => {
	return utils.parseUnits(value, decimals)
}

export const toLocaleNumber = (value: number, digits: number = 4) => {
	let formatted = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: digits + 1,
		minimumSignificantDigits: digits + 1,
	}).format(value)
	let index = formatted.indexOf('.')
	return index > 0 ? formatted.substring(0, index + digits + 1) : formatted
}

export function toNumber(value: string | null, defaultValue = 0): number {
	if (value === null) {
		return defaultValue
	}

	const numberValue = Number.parseInt(value, 10)

	if (Number.isNaN(numberValue)) {
		return defaultValue
	}

	return numberValue
}

export const renderAmount = (
	value: number | string | undefined,
	digits: number = 4
) => {
	const v = typeof value === 'string' ? Number.parseFloat(value) : value || 0
	if (v === 0) return '0'
	const formatted = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: digits + 1,
		minimumSignificantDigits: digits + 1,
	}).format(v)
	const index = formatted.indexOf('.')
	return index > 0 ? formatted.substring(0, index + digits + 1) : formatted
}
